import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getLectureMaterials as getLectureMaterialsApi } from "@/services/apiLectureContent";

export function useLectureMaterials({ courseId, lectureId, apiOperations: { page, perPage = 5 } }) {
  const queryClient = useQueryClient();

  const {
    isPending,
    data: lectureMaterials,
    error,
  } = useQuery({
    queryKey: ["lectureMaterials", courseId, lectureId, page, perPage],
    queryFn: () =>
      getLectureMaterialsApi({
        courseId,
        lectureId,
        apiOperations: { page, perPage },
      }),
    retry: false,
  });

  const totalPages = Math.ceil(lectureMaterials?.meta.total / lectureMaterials?.meta.per_page);

  //PRE-FETCHING
  if (!isPending && page < totalPages) {
    queryClient.prefetchQuery({
      queryKey: ["lectureMaterials", courseId, lectureId, page, perPage],
      queryFn: () =>
        getLectureMaterialsApi({
          courseId,
          lectureId,
          apiOperations: { page: page++, perPage },
        }),
    });
  }

  if (!isPending && page > 1) {
    queryClient.prefetchQuery({
      queryKey: ["lectureMaterials", courseId, lectureId, page, perPage],
      queryFn: () =>
        getLectureMaterialsApi({
          courseId,
          lectureId,
          apiOperations: { page: page--, perPage },
        }),
    });
  }

  return { isPending, lectureMaterials, error };
}
